export default __webpack_public_path__ + "static/media/ic_gmx_footer.e3644403.svg";